module.exports = __webpack_public_path__ + "img/Question.60607194.svg";